/**
 * Production asset configuration.
 * CDN-ready: set REACT_APP_ASSET_URL for CloudFront, BunnyCDN, etc.
 * Never hardcode domains.
 */
export const ASSET_BASE = (process.env.REACT_APP_ASSET_URL || "").replace(/\/$/, "");
export const IS_CDN = Boolean(process.env.REACT_APP_ASSET_URL);

/** Normalize path: root-based, no ./ or ../. Absolute URLs (http/https) bypass ASSET_BASE. */
export function assetUrl(path) {
  if (!path || typeof path !== "string") return "";
  if (/^https?:\/\//i.test(path)) return path;
  let p = path.replace(/^\.\/|^\.\.\//g, "").replace(/\\/g, "/").trim();
  if (!p.startsWith("/")) p = `/${p}`;
  return ASSET_BASE ? `${ASSET_BASE}${p}` : p;
}

/** Models base — match public folder names (case-sensitive on Linux/Netlify) */
export const MODELS_3D_BASE = "/3Dmodels";
export const MODELS_2D_BASE = "/2Dmodels";
export const DESIGNS_BASE = "/designs";
export const HDR_BASE = "/hdr";
export const DRACO_DECODER = "https://www.gstatic.com/draco/v1/decoders/";

/** Resolve model path (lowercase for deployment consistency) */
export function modelPath(base, filename) {
  const clean = (filename || "").replace(/^\/+/, "").toLowerCase();
  return assetUrl(`${base}/${clean}`);
}
